import { render, staticRenderFns } from "./prepare-suggestions-modal.vue?vue&type=template&id=6e10033d&scoped=true"
import script from "./prepare-suggestions-modal.vue?vue&type=script&lang=js"
export * from "./prepare-suggestions-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10033d",
  null
  
)

export default component.exports